/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Sign_AcInputs */

const en_pc_cmp_r_sign_ac = /** @type {(inputs: Pc_Cmp_R_Sign_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request and collect e-signatures`)
};

const zh_pc_cmp_r_sign_ac = /** @type {(inputs: Pc_Cmp_R_Sign_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可发起并收集电子签名`)
};

/**
* | output |
* | --- |
* | "Request and collect e-signatures" |
*
* @param {Pc_Cmp_R_Sign_AcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_sign_ac = /** @type {((inputs?: Pc_Cmp_R_Sign_AcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Sign_AcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_sign_ac(inputs)
	return zh_pc_cmp_r_sign_ac(inputs)
});
export { pc_cmp_r_sign_ac as "pc.cmp.r.sign.ac" }